import { __awaiter, __generator } from "tslib";
import { useFormik } from 'formik';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import StarRatings from 'react-star-ratings';
import './CloseReviewWidget.scss';
var CloseReviewWidget = function (props) {
    var initial_data = useSelector(function (state) { var _a, _b; return (_b = (_a = state === null || state === void 0 ? void 0 : state.domain) === null || _a === void 0 ? void 0 : _a.arbitrary) === null || _b === void 0 ? void 0 : _b.initial_data; });
    var handleSubmit = props.handleSubmit, handleCancel = props.handleCancel;
    var _a = useState(), firstTime = _a[0], setFirstTime = _a[1];
    var _b = useState(0), rating = _b[0], setRating = _b[1];
    var initialValues = {
        stars: null,
        firstTime: '',
        text: '',
    };
    var validate = function (values) {
        var errors = {};
        // mandatory for both kind and !kind
        if (typeof values.firstTime !== 'boolean') {
            errors.firstTime = 'Povinné';
        }
        // mandatory for both kind and !kind
        if (!values.stars) {
            errors.stars = 'Povinné';
        }
        return errors;
    };
    var formik = useFormik({
        initialValues: initialValues,
        validate: validate,
        onSubmit: function (_a) {
            var text = _a.text, first = _a.firstTime, stars = _a.stars;
            return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    handleSubmit({
                        on_close_rating_widget_star_rating: stars,
                        on_close_rating_widget_comment: text,
                        on_close_rating_widget_like_dislike: first ? 'Like' : 'Dislike',
                    });
                    return [2 /*return*/];
                });
            });
        },
    });
    var setStars = function (value) {
        setRating(value);
        formik.values.stars = value;
    };
    var setFirstTimeValue = function (e, value) {
        values.firstTime = value;
        setFirstTime(value);
        handleChange(e);
    };
    var errors = formik.errors, values = formik.values, handleChange = formik.handleChange, validateForm = formik.validateForm, submitForm = formik.submitForm, resetForm = formik.resetForm, isSubmitting = formik.isSubmitting;
    var _renderForm = function () {
        var textareaPlaceholder = 'Prosím napište hodnocení konverzace';
        return (React.createElement("div", { className: "center flex column" },
            React.createElement("p", { className: "mb-8" }, "Jak jste byli spokojeni s odpov\u011Bd\u00ED?"),
            React.createElement("div", { className: "mb-24" },
                React.createElement(StarRatings, { rating: rating, starRatedColor: "#fdd827", starHoverColor: "#fdd827", starEmptyColor: "none", starDimension: "24px", onChange: function (e) {
                        handleChange(e);
                    }, changeRating: function (newRating) {
                        setStars(newRating);
                    }, numberOfStars: 5, name: "rating" }),
                React.createElement("br", null),
                errors.stars && React.createElement("span", { className: "error" }, errors.stars)),
            React.createElement("div", { className: "mb-24 mt-8 flex column" },
                React.createElement("textarea", { placeholder: textareaPlaceholder, value: values.text, name: "text", id: "text", onChange: handleChange, className: errors.text && 'error' })),
            React.createElement("div", { className: "mb-24 first-time" },
                React.createElement("p", { className: "mb-8" }, "Dostali jste odpov\u011B\u010F napoprv\u00E9?"),
                React.createElement("div", { className: "flex" },
                    React.createElement("div", { className: "mr-8" },
                        React.createElement("button", { className: "btn ".concat(firstTime && 'selected'), onClick: function (e) { return setFirstTimeValue(e, true); } },
                            React.createElement(LikeIcon, { selected: !!firstTime }),
                            "Ano")),
                    React.createElement("div", null,
                        React.createElement("button", { className: "btn dislike ".concat(firstTime === false && 'selected'), onClick: function (e) { return setFirstTimeValue(e, false); } },
                            React.createElement(LikeIcon, { dislike: true, selected: firstTime === false }),
                            "Ne"))),
                errors.firstTime && (React.createElement("div", null,
                    React.createElement("span", { className: "error" }, errors.firstTime)))),
            React.createElement("button", { type: "submit", disabled: isSubmitting, className: "btn btn-submit", onClick: function (e) {
                    e.preventDefault();
                    if (validateForm(values))
                        submitForm();
                } }, "Odeslat hodnocen\u00ED")));
    };
    return (React.createElement("form", { className: "closeReview-widget flex center column", onSubmit: function (e) {
            e.preventDefault();
        } },
        _renderForm(),
        React.createElement("button", { className: "cancel", onClick: function () {
                resetForm();
                handleCancel();
            } }, "Zp\u011Bt do konverzace"),
        React.createElement("button", { className: "cancel", onClick: function () {
                resetForm();
                handleSubmit({
                    on_close_rating_widget_star_rating: null,
                    on_close_rating_widget_comment: '',
                    on_close_rating_widget_like_dislike: '',
                });
            } }, "Zav\u0159\u00EDt bez hodnocen\u00ED")));
};
var LikeIcon = function (_a) {
    var _b = _a.dislike, dislike = _b === void 0 ? false : _b, _c = _a.selected, selected = _c === void 0 ? false : _c;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", version: "1.0", viewBox: "0 0 442 407", fill: selected ? 'white' : '#000862', transform: dislike ? 'scale(1 -1)' : '' },
        React.createElement("path", { d: "M254 22.7c-6.3 1.1-10.1 2.6-13 5-5.5 4.5-7.1 9.2-8.6 24.8-.7 7.9-1.8 16.5-2.5 19.1-3.3 13.8-11.8 24.9-28.6 37.5-32 24-49.6 44-64.7 73.6-6.5 12.7-11.1 17.6-18.1 19.4-2.7.7-5.4 2.2-6.5 3.7-2 2.4-2 4.3-2 82.4 0 84.9 0 85.2 4.7 87.6 2.5 1.4 6.1 1.8 38.8 5.2 64 6.5 82.8 7.4 124 6 35.9-1.2 47-2.6 56.1-7 9.9-4.8 13.8-12.1 16.8-30.9l1.5-9.4 7.4-7.1c9.6-9.3 12.2-14.6 12.2-24.7 0-6.7-.4-8.3-3.9-15.3l-3.8-7.8 6.5-6.7c13.2-13.3 13.8-22.5 2.7-41.2l-4-6.7 4.1-9.1c5.5-12.6 6.6-18.3 5.1-27.1-2.2-12.8-7.2-19.9-17.2-24.3-14.2-6.3-28.5-7.8-68.7-7.5l-31.1.3-2.6-2.4c-5.1-4.8-3.8-9.2 15.3-51.3 9.1-20 11.5-29.6 10.9-43.3-.8-15.6-7.9-34.5-15.1-39.6-2.5-1.8-9.3-4-11.7-3.8-.8.1-2.6.4-4 .6zM37.5 203.1c-4.7 2.6-4.5-.4-4.5 87.9v83.7l2.6 2.4c2.6 2.4 2.6 2.4 28.2 2.7 28 .3 31.3.1 34.3-2.9 1.9-1.9 1.9-4 1.9-85.8 0-81.1-.1-84-1.9-86.2l-1.9-2.4-28.4-.2c-19.4-.2-28.9.1-30.3.8z" })));
};
export default CloseReviewWidget;
